import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { availabilityCountValue } from '../../models/dashboard/settings/availableCountmodel';

interface AvailabilityCountState {
  count: number;
}

const initialState: AvailabilityCountState = availabilityCountValue;

const availabilityCountSlice = createSlice({
  name: 'availabilityCount',
  initialState,
  reducers: {
    setAvailabilityCount: (state, action: PayloadAction<number>) => {
      state.count = action.payload;
    },
  },
});

export const { setAvailabilityCount } = availabilityCountSlice.actions;
export default availabilityCountSlice.reducer;
